// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"124df425","333":"1660309b","850":"97f8544b"}[chunkId] + ".chunk.css";
};